import React, { useState } from "react";
import axios from "axios";

const baseURL = import.meta.env.VITE_API_URL;

const ReportFinance = () => {
  const [file, setFile] = useState(null);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [isFileDownloaded, setIsFileDownloaded] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const role = localStorage.getItem("role");
  const businessCode = localStorage.getItem("businessCode");
  const businessName = localStorage.getItem("businessName");

  const clearData = () => {
    setFile(null);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      if (role === "admin") {
        await handleFileUpload();
      } else {
        await handleFileDownload();
      }
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!file && role === "admin") {
      errors.file = "File is required";
    }
    return errors;
  };

  const handleFileUpload = async () => {
    setLoading(true);
    clearData();
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(
        `${baseURL}/upload/finance?BusinessCode=${businessName}`,
        formData
      );
      if (response.status === 200) {
        setIsFileUploaded(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileDownload = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${baseURL}/download/finance?BusinessCode=${businessName}`,
        { responseType: "blob" }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "finance_report.pdf";
        a.click();
        setIsFileDownloaded(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 pt-20 px-5">
      <div className="max-w-7xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          Report Finance
        </h2>
        {role === "admin" ? (
          <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6 mb-6">
            <div>
              <label
                htmlFor="file"
                className="block mb-2 text-sm font-medium text-gray-700"
              >
                Upload File
              </label>
              <input
                type="file"
                accept=".pdf, .xlsx, .csv, .docx"
                onChange={handleFileChange}
                className={`p-3 border w-full rounded-lg focus:outline-none focus:ring-2 ${errors.file
                    ? "border-red-500 focus:ring-red-500"
                    : "focus:ring-blue-500"
                  }`}
              />
              {errors.file && (
                <p className="text-red-500 text-sm mt-1">{errors.file}</p>
              )}
            </div>
            <button
              type="submit"
              className="bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-300"
            >
              Upload File
            </button>
          </form>
        ) : (
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-300"
          >
            Download File
          </button>
        )}
        {loading && <p className="text-blue-600">Loading...</p>}
        {isFileUploaded && (
          <p className="text-green-600">File uploaded successfully!</p>
        )}
        {isFileDownloaded && (
          <p className="text-green-600">File downloaded successfully!</p>
        )}
      </div>
    </div>
  );
};

export default ReportFinance;